/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LookupIEnumerableResponseVM } from '../models/LookupIEnumerableResponseVM';
import type { PropertyVM } from '../models/PropertyVM';
import type { PropertyVMIEnumerableResponseVM } from '../models/PropertyVMIEnumerableResponseVM';
import type { PropertyVMResponseVM } from '../models/PropertyVMResponseVM';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PropertyService {
    /**
     * @returns PropertyVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiProperty(): CancelablePromise<PropertyVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Property',
        });
    }
    /**
     * @param requestBody
     * @returns PropertyVMResponseVM Success
     * @throws ApiError
     */
    public static postApiProperty(
        requestBody?: PropertyVM,
    ): CancelablePromise<PropertyVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Property',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PropertyVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPropertyOrganizationlist(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PropertyVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Property/{organizationId}/organizationlist',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns LookupIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPropertyOrganizationlookup(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<LookupIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Property/{organizationId}/organizationlookup',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param propertyId
     * @returns PropertyVMResponseVM Success
     * @throws ApiError
     */
    public static getApiProperty1(
        propertyId: number,
    ): CancelablePromise<PropertyVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Property/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
        });
    }
    /**
     * @param propertyId
     * @param requestBody
     * @returns PropertyVMResponseVM Success
     * @throws ApiError
     */
    public static putApiProperty(
        propertyId: string,
        requestBody?: PropertyVM,
    ): CancelablePromise<PropertyVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Property/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param propertyId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiProperty(
        propertyId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Property/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
        });
    }
}
